<style lang="stylus">
    .OpenLibrary-mask
        modal-mask()
        .OpenLibrary-modal
            width 480px
            .dialog-slot{
              padding-top: 14px
            }
            .OpenLibrary-container
                margin-bottom: 24px
                .OpenLibrary-import
                    display flex
                    justify-content space-between
                    margin-bottom 10px
                    .import-showTitle
                        line-height 24px
                    .import-showText
                        width: 270px;
                        height: 24px;
                        line-height 24px
                        text-indent 10px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        border: 1px solid var(--border-color-box-6);
                        border-radius: 6px;
                    .dialog-btn{
                      margin-left: 0
                    }
                    .import-btn
                        width 71px
                        height 24px
                        text-align center
                        line-height 22px
                        font-size 12px
                        cursor pointer
                        user-select none
                        &:hover
                            border-color var(--themeColor)
                            box-shadow none
                    input
                        display none
</style>

<template>
    <div class="OpenLibrary-mask">
        <Dialog class="OpenLibrary-modal" :title="$t('title')" :isShow="true" @close="closeModal">
            <div class="OpenLibrary-container">
                <div class="OpenLibrary-import">
                    <p class="import-showTitle">{{ $t("edtfile") }}:</p>
                    <div ref="edtText" class="import-showText"></div>
                    <div class="import-btn dialog-btn" @click="importBtn('edt')">{{ $t("importBtn") }}</div>
                    <input ref="edtImporter" type="file" accept=".edt" @change="getEdt($event)" />
                </div>
                <div class="OpenLibrary-import">
                    <p class="import-showTitle">{{ $t("edlfile") }}:</p>
                    <div ref="edlText" class="import-showText"></div>
                    <div class="import-btn dialog-btn" @click="importBtn('edl')">{{ $t("importBtn") }}</div>
                    <input ref="edlImporter" type="file" accept=".edl" @change="getEdl($event)" />
                </div>
            </div>

            <div class="dialog-btnbox-normal">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "../Dialog.vue";
    import appConfig from "@/public/globalConfig";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class OpenLibrary extends Vue {
        @Inject()
        ["showMessage"];

        edt: any;
        edl: any;
        openDBName: string = "";
        openTableName: string = "";
        openDBVersion: number = 0;
        timer: number = 0;
        userWorkerURL: string = appConfig.userWorkerURL;

        libraryWorkerURL: string = appConfig.libraryWorkerURL;
        importBtn(type) {
            let edt = this.$refs.edtImporter as HTMLInputElement;
            let edl = this.$refs.edlImporter as HTMLInputElement;
            (type == "edt" && (edt.click(), true)) || edl.click();
        }
        getEdt(e) {
            let edt = this.$refs.edtText as HTMLElement;
            edt.innerHTML = e.target.files[0].name;
            this.edt = e.target.files[0];
            let name = e.target.files[0].name;
            this.openTableName = name.substring(0, name.length - 4).substring(0, 32);
            e.target.value = null;
        }
        getEdl(e) {
            let edl = this.$refs.edlText as HTMLElement;
            edl.innerHTML = e.target.files[0].name;
            this.edl = e.target.files[0];
            e.target.value = null;
        }

        toggleLoading(type) {
            // 下载数据，禁止用户点击
            this.$store.commit("setStatus", {
                type: "Loading",
                data: type,
            });
            this.timer = setTimeout(() => {
                // 不管成功失败 15s后取消loading
                this.$store.commit("setStatus", {
                    type: "Loading",
                    data: false,
                });
            }, 15000);
        }
        checkFileName() {
            let edt = this.$refs.edtText as HTMLElement;
            let edl = this.$refs.edlText as HTMLElement;
            let edtName = edt.innerHTML.substring(0, edt.innerHTML.length - 4);
            let edlName = edl.innerHTML.substring(0, edl.innerHTML.length - 4);
            return edlName == edtName && edlName != "";
        }
        confirm() {
            if (!this.checkFileName()) {
                this.showMessage({
                    type: 2,
                    imgType: 2,
                    time: 3,
                    content: this.$t("illegal"),
                });
                return;
            }
            let getNewName = () => {
                let list = this.$store.state.library.menuList[0].children;
                let nameList = [];
                let newName = this.openTableName;
                let checkName = (name, list) => {
                    let exit = 0,
                        exitExpand = 0,
                        exitFlag = true,
                        numList = [];
                    let p = new RegExp("(?=[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%])", "g"),
                        ruleone = new RegExp("\^" + name.replace(p, "\\") + "\\\(\\\d+\\\)$"),
                        ruletwo = new RegExp("\^" + name.replace(p, "\\") + "\\\((\\\d*)");

                    for (let v of list) {
                        if (exitFlag && v == name) {
                            exit = 1;
                            exitFlag = false;
                        }
                        if (ruleone.test(v)) {
                            let tempNum = ~~v.match(ruletwo)[1];
                            if (tempNum > 0) {
                                numList.push(tempNum);
                                exitExpand = 1;
                            }
                        }
                    }

                    if (exit == 0) {
                        return name;
                    } else {
                        if (exitExpand != 1) {
                            return `${name}(1)`;
                        } else {
                            numList = numList.sort((a, b) => {
                                return a - b;
                            });
                            var k;
                            for (var i = 0, len = numList.length; i < len; i++) {
                                if (i + 1 != numList[i]) {
                                    k = i + 1;
                                    break;
                                } else {
                                    k = numList[len - 1] + 1;
                                }
                            }
                            return `${name}(${k})`;
                        }
                    }
                };
                for (let i = 0; i < list.length; i++) {
                    nameList.push(list[i].tableName);
                }

                return checkName(newName, nameList);
            };
            let uploadStoreInfo = (tableArr) => {
                let menu = this.$store.state.library.menuList;
                let showList = this.$store.state.library.displayList;
                let checkbox = JSON.parse(JSON.stringify(this.$store.state.library.checkbox));
                let DBName = this.openDBName;
                let tableName = this.openTableName;

                checkbox[DBName].push(tableArr[0].id);
                this.$store.state.library.checkbox = checkbox;

                for (let i = 0; i < menu.length; i++) {
                    // 更新用户自定义库的表名
                    if (menu[i].groupName == DBName) {
                        menu[i].children = menu[i].children.concat(tableArr);
                    }
                }
                for (let i = 0; i < showList.length; i++) {
                    if (showList[i].groupName == DBName) {
                        showList[i].children.push({
                            tableName: tableName,
                            showList: [],
                        });
                    }
                }
            };
            let userInfo = this.$store.state.user.userInfo;
            let ts: any = this;
            let worker = new Worker(this.userWorkerURL);

            this.openTableName = getNewName(); // 查重名称
            let createData = {
                DBName: this.openDBName,
                tableName: this.openTableName,
                edl: this.edl,
                edt: this.edt,
                versionDB: `myDBVersion_${userInfo.user_id}`,
                userInfo: {
                    id: userInfo.user_id,
                    token: userInfo.token,
                },
                libType: 0,
            };
            worker.postMessage({
                type: "createWithEDT",
                urls: this.urls,
                data: createData,
            });
            worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "newOK") {
                    worker.terminate();
                    uploadStoreInfo(message.children);
                    console.log("success");
                    ts.$bus.$asyncEmit("uploadToCloud", { message });
                }
            };
            this.closeModal();
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        mounted() {
            console.log(1111111111);
        }

        created() {
            this.openDBName = this.$store.state.library.extraDB[2];
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "打开本地库",
    "edtfile": "edt文件",
    "edlfile": "edl文件",
    "importBtn": "浏览",
    "confirm": "确定",
    "cancel": "取消",
    "illegal": "请选择正确的edl及edt文件"
  },
  "en": {
    "title": "Open Library",
    "edtfile": "*.edt file",
    "edlfile": "*.edl file",
    "importBtn": "Browse",
    "confirm": "OK",
    "cancel": "Cancel",
    "illegal": "Please select the correct EDL and EDT files"
  },
  "fr": {
    "title": "Ouvrir la bibliothèque locale",
    "edtfile": "Fichier edt",
    "edlfile": "Fichier edl",
    "importBtn": "Parcourir",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "illegal": "Veuillez sélectionner les fichiers edl et edt corrects"
  },
  "de": {
    "title": "Bibliothek öffnen",
    "edtfile": "*.ede Datei",
    "edlfile": "*.edl Datei",
    "importBtn": "Browsen",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "illegal": "Bitte wählen Sie die richtigen edl- und edt-Dateien aus"
  },
  "jp": {
    "title": "ローカルライブラリを開く",
    "edtfile": "edtファイル",
    "edlfile": "edlファイル",
    "importBtn": "参照",
    "confirm": "OK",
    "cancel": "キャンセル",
    "illegal": "正しいedlとedtファイルを選択してください。"
  },
  "es": {
    "title": "Abrir biblioteca local",
    "edtfile": "Alchivo edt",
    "edlfile": "Alchivo edl",
    "importBtn": "Examinar",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "illegal": "Selecciona los archivos EDL y EDT correctos"
  },
  "pt": {
    "title": "Abrir Biblioteca",
    "edtfile": "ficheiro *.edt",
    "edlfile": "ficheiro *.edl",
    "importBtn": "Navegar",
    "confirm": "OK",
    "cancel": "Cancelar",
    "illegal": "Selecione os arquivos EDL e EDT corretos"
  },
  "it": {
    "title": "Libreria Aperta",
    "edtfile": "File *.edt",
    "edlfile": "File *.edl",
    "importBtn": "Sfoglia",
    "confirm": "OK",
    "cancel": "Annulla",
    "illegal": "Seleziona i file edl e edt corretti"
  },
  "tw": {
    "title": "打開本地庫",
    "edtfile": "edt檔案",
    "edlfile": "edl檔案",
    "importBtn": "瀏覽",
    "confirm": "確定",
    "cancel": "取消",
    "illegal": "請選擇正確的edl及edt檔案"
  },
  "kr": {
    "title": "라이브러리 열기",
    "edtfile": "edt파일 ",
    "edlfile": "edl파일 ",
    "importBtn": "둘러보기",
    "confirm": "확인 ",
    "cancel": "취소 ",
    "illegal": "올바른 EDL 및 EDT 파일을 선택하세요"
  }
}
</i18n>
